import clsx from "clsx";
import {
  Cell as RACCell,
  CellProps as RACCellProps,
  composeRenderProps,
} from "react-aria-components";
import { cellStyles, centerAlignedCell, endAlignedCell } from "./tables.css";
import { Align } from "./types";

interface CellProps extends RACCellProps {
  /**
   * Logical text alignment for the cell.
   * Use "start" by default and "end" for numeric values.
   */
  align?: Align;
}

const alignStyles: Record<Align, string> = {
  start: cellStyles,
  end: endAlignedCell,
  center: centerAlignedCell,
};

const Cell = ({
  children,
  align = "start",
  className,
  ...props
}: CellProps) => (
  <RACCell
    // Keep our alignment class, then merge any className the caller passes.
    // Caller className can be a string or a function—useful for styling in sortable tables
    // (e.g. highlighting cells in the currently sorted column).
    className={composeRenderProps(className, (resolvedClassName) =>
      clsx(alignStyles[align], resolvedClassName),
    )}
    {...props}
  >
    {children}
  </RACCell>
);

export default Cell;
